// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22.5H2V10.5H22V22.5ZM6 19.5H16V17.5H6V19.5ZM6 15.5H12V13.5H6V15.5ZM8 4.5H16V1.5H18V4.5H22V8.5H2V4.5H6V1.5H8V4.5Z"}}]};

const Calendar3FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calendar-3-filled',
    ref,
    icon: element,
  },
));

Calendar3FilledIcon.displayName = 'Calendar3FilledIcon';

export default Calendar3FilledIcon;
